/**
 * @generated SignedSource<<b6db08a66f2bc9c09c79494a81ce6be8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PeopleFieldType = "DEPARTMENT" | "JOB_TITLE" | "LOCATION";
export type StaffDirectoryViewQuery$variables = {
  cloudId: string;
  first?: number | null;
  isBrowseAllScreen: boolean;
  isBrowsePeopleScreen: boolean;
  isSearchAllScreen: boolean;
  isSearchKudosScreen: boolean;
  isSearchPeopleScreen: boolean;
  isSearchTeamsScreen: boolean;
  kudosEnabled: boolean;
  kudosQuery: string;
  organisationId: string;
  peopleFieldType: PeopleFieldType;
  teamQuery: string;
  useCloudId: boolean;
  userQuery: string;
  workspaceId: string;
};
export type StaffDirectoryViewQuery$data = {
  readonly explainKudosTql?: {
    readonly explanation: string | null;
  } | null;
  readonly explainUserTql?: {
    readonly explanation: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BrowseAllScreenQuery" | "BrowsePeopleFieldsScreenQuery" | "SearchAllScreen_data" | "SearchKudosScreen_data" | "SearchPeopleScreen_data" | "SearchTeamsScreen_data">;
};
export type StaffDirectoryViewQuery = {
  response: StaffDirectoryViewQuery$data;
  variables: StaffDirectoryViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBrowseAllScreen"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBrowsePeopleScreen"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchAllScreen"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchKudosScreen"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchPeopleScreen"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchTeamsScreen"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kudosEnabled"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kudosQuery"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "peopleFieldType"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamQuery"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useCloudId"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userQuery"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v16 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "userQuery"
},
v17 = [
  {
    "kind": "ScalarField",
    "name": "explanation"
  }
],
v18 = {
  "condition": "isSearchKudosScreen",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": "explainUserTql",
      "args": [
        {
          "kind": "Literal",
          "name": "entity",
          "value": "PERSON"
        },
        (v16/*: any*/)
      ],
      "concreteType": "TQLExplanation",
      "kind": "LinkedField",
      "name": "explainTql",
      "plural": false,
      "selections": (v17/*: any*/)
    }
  ]
},
v19 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "kudosQuery"
},
v20 = {
  "alias": "explainKudosTql",
  "args": [
    {
      "kind": "Literal",
      "name": "entity",
      "value": "KUDOS"
    },
    (v19/*: any*/)
  ],
  "concreteType": "TQLExplanation",
  "kind": "LinkedField",
  "name": "explainTql",
  "plural": false,
  "selections": (v17/*: any*/)
},
v21 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v22 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v23 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v24 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "userQuery"
},
v25 = {
  "kind": "Variable",
  "name": "query",
  "variableName": "teamQuery"
},
v26 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v27 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v28 = {
  "kind": "Variable",
  "name": "peopleFieldType",
  "variableName": "peopleFieldType"
},
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  },
  (v19/*: any*/),
  (v27/*: any*/)
],
v30 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v31 = {
  "kind": "ScalarField",
  "name": "ari"
},
v32 = {
  "kind": "ScalarField",
  "name": "description"
},
v33 = {
  "kind": "ScalarField",
  "name": "imageUrl"
},
v34 = {
  "kind": "ScalarField",
  "name": "stillImageUrl"
},
v35 = {
  "kind": "ScalarField",
  "name": "type"
},
v36 = {
  "kind": "ScalarField",
  "name": "bgTheme"
},
v37 = {
  "kind": "ScalarField",
  "name": "name"
},
v38 = {
  "kind": "ScalarField",
  "name": "picture"
},
v39 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v40 = {
  "kind": "ScalarField",
  "name": "id"
},
v41 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "giver",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v37/*: any*/),
        (v38/*: any*/),
        (v39/*: any*/)
      ]
    },
    (v40/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "teamId"
},
v43 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "KudosRecipientConnection",
  "kind": "LinkedField",
  "name": "recipients",
  "plural": false,
  "selections": [
    {
      "concreteType": "KudosRecipientEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "KudosRecipient",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "recipient",
              "plural": false,
              "selections": [
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v39/*: any*/),
                    (v37/*: any*/),
                    (v38/*: any*/)
                  ]
                },
                (v40/*: any*/)
              ]
            },
            {
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "team",
              "plural": false,
              "selections": [
                (v37/*: any*/),
                (v42/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "avatarUrl"
                },
                (v40/*: any*/)
              ]
            },
            (v40/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "recipients(first:1)"
},
v44 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v45 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v46 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v47 = [
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v16/*: any*/)
],
v48 = {
  "kind": "ScalarField",
  "name": "account_id"
},
v49 = {
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "MEDIUM"
    }
  ],
  "concreteType": "HighResolutionProfilePicture",
  "kind": "LinkedField",
  "name": "highResolutionProfilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ],
  "storageKey": "highResolutionProfilePicture(size:\"MEDIUM\")"
},
v50 = {
  "kind": "ScalarField",
  "name": "job_title"
},
v51 = {
  "concreteType": "ReportCounts",
  "kind": "LinkedField",
  "name": "reportCounts",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "directReports"
    }
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "location"
},
v53 = {
  "kind": "ScalarField",
  "name": "zoneinfo"
},
v54 = {
  "concreteType": "TeamConnection",
  "kind": "LinkedField",
  "name": "teams",
  "plural": false,
  "selections": [
    {
      "concreteType": "TeamEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v37/*: any*/),
            (v42/*: any*/),
            (v40/*: any*/)
          ]
        }
      ]
    }
  ]
},
v55 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "teamQuery"
},
v56 = [
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v55/*: any*/)
],
v57 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v58 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v59 = {
  "kind": "ScalarField",
  "name": "smallAvatarImageUrl"
},
v60 = {
  "kind": "ScalarField",
  "name": "largeAvatarImageUrl"
},
v61 = {
  "kind": "ScalarField",
  "name": "count"
},
v62 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v38/*: any*/)
  ]
},
v63 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v64 = {
  "concreteType": "TeamMemberConnection",
  "kind": "LinkedField",
  "name": "members",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    {
      "concreteType": "TeamMemberEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TeamMember",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v62/*: any*/),
            (v63/*: any*/)
          ]
        }
      ]
    }
  ]
},
v65 = [
  "q",
  "organisationId",
  "cloudId"
],
v66 = {
  "kind": "Literal",
  "name": "peopleFieldType",
  "value": "DEPARTMENT"
},
v67 = {
  "concreteType": "PeopleFieldAggregate",
  "kind": "LinkedField",
  "name": "results",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    {
      "kind": "ScalarField",
      "name": "imageDirectoryUrl"
    }
  ]
},
v68 = [
  (v67/*: any*/),
  {
    "concreteType": "PeopleFieldAggregateError",
    "kind": "LinkedField",
    "name": "errors",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "message"
      }
    ]
  }
],
v69 = {
  "kind": "Literal",
  "name": "peopleFieldType",
  "value": "LOCATION"
},
v70 = {
  "kind": "Literal",
  "name": "peopleFieldType",
  "value": "JOB_TITLE"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StaffDirectoryViewQuery",
    "selections": [
      (v18/*: any*/),
      {
        "condition": "isSearchKudosScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v20/*: any*/)
        ]
      },
      {
        "args": [
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "kind": "Variable",
            "name": "isSearchAllScreen",
            "variableName": "isSearchAllScreen"
          },
          (v23/*: any*/),
          {
            "kind": "Variable",
            "name": "teamQuery",
            "variableName": "teamQuery"
          },
          {
            "kind": "Variable",
            "name": "userQuery",
            "variableName": "userQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SearchAllScreen_data"
      },
      {
        "args": [
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "kind": "Variable",
            "name": "isSearchPeopleScreen",
            "variableName": "isSearchPeopleScreen"
          },
          (v23/*: any*/),
          (v24/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SearchPeopleScreen_data"
      },
      {
        "args": [
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "kind": "Variable",
            "name": "isSearchTeamsScreen",
            "variableName": "isSearchTeamsScreen"
          },
          (v23/*: any*/),
          (v25/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SearchTeamsScreen_data"
      },
      {
        "condition": "isBrowseAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v21/*: any*/),
              (v26/*: any*/),
              {
                "kind": "Variable",
                "name": "kudosEnabled",
                "variableName": "kudosEnabled"
              },
              {
                "kind": "Literal",
                "name": "kudosFirst",
                "value": 5
              },
              {
                "kind": "Variable",
                "name": "kudosQuery",
                "variableName": "kudosQuery"
              },
              (v23/*: any*/),
              (v25/*: any*/),
              {
                "kind": "Variable",
                "name": "useCloudId",
                "variableName": "useCloudId"
              },
              (v27/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "BrowseAllScreenQuery"
          }
        ]
      },
      {
        "condition": "isBrowsePeopleScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v21/*: any*/),
              (v28/*: any*/),
              (v24/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "BrowsePeopleFieldsScreenQuery"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isSearchKudosScreen",
            "variableName": "isSearchKudosScreen"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "kudosQuery"
          },
          (v27/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SearchKudosScreen_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v12/*: any*/),
      (v14/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v10/*: any*/),
      (v15/*: any*/),
      (v0/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Operation",
    "name": "StaffDirectoryViewQuery",
    "selections": [
      (v18/*: any*/),
      {
        "condition": "isSearchKudosScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v20/*: any*/),
          {
            "args": (v29/*: any*/),
            "concreteType": "KudosConnection",
            "kind": "LinkedField",
            "name": "kudosTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "KudosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Kudos",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v41/*: any*/),
                      (v43/*: any*/),
                      (v40/*: any*/),
                      (v44/*: any*/)
                    ]
                  },
                  (v45/*: any*/)
                ]
              },
              (v46/*: any*/)
            ]
          },
          {
            "args": (v29/*: any*/),
            "filters": [
              "q",
              "workspaceId"
            ],
            "handle": "connection",
            "key": "SearchKudosScreen_kudosTql",
            "kind": "LinkedHandle",
            "name": "kudosTql"
          }
        ]
      },
      {
        "condition": "isSearchAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v47/*: any*/),
            "concreteType": "CpusSearchUserConnection",
            "kind": "LinkedField",
            "name": "peopleTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "CpusSearchUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "CpusSearchUser",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v48/*: any*/),
                      (v37/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "searchTeams",
            "args": (v56/*: any*/),
            "concreteType": "TeamSearchResponseConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamSearchResponse",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v32/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v64/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isSearchPeopleScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v47/*: any*/),
            "concreteType": "CpusSearchUserConnection",
            "kind": "LinkedField",
            "name": "peopleTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "CpusSearchUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "CpusSearchUser",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v48/*: any*/),
                      (v37/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v44/*: any*/)
                    ]
                  },
                  (v45/*: any*/)
                ]
              },
              (v46/*: any*/)
            ]
          },
          {
            "args": (v47/*: any*/),
            "filters": (v65/*: any*/),
            "handle": "connection",
            "key": "SearchPeopleScreen_peopleTql",
            "kind": "LinkedHandle",
            "name": "peopleTql"
          }
        ]
      },
      {
        "condition": "isSearchTeamsScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "searchTeams",
            "args": (v56/*: any*/),
            "concreteType": "TeamSearchResponseConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamSearchResponse",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v32/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v64/*: any*/),
                      (v44/*: any*/)
                    ]
                  },
                  (v45/*: any*/)
                ]
              },
              (v46/*: any*/)
            ]
          },
          {
            "alias": "searchTeams",
            "args": (v56/*: any*/),
            "filters": (v65/*: any*/),
            "handle": "connection",
            "key": "SearchTeamsScreen_searchTeams",
            "kind": "LinkedHandle",
            "name": "teamsTql"
          }
        ]
      },
      {
        "condition": "isBrowseAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "browseTeams",
            "args": [
              (v21/*: any*/),
              (v26/*: any*/),
              (v23/*: any*/),
              (v55/*: any*/),
              {
                "kind": "Literal",
                "name": "sort",
                "value": [
                  "NAME_ASC"
                ]
              }
            ],
            "concreteType": "TeamSearchResponseConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamSearchResponse",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      (v57/*: any*/),
                      (v32/*: any*/),
                      (v58/*: any*/),
                      (v59/*: any*/),
                      {
                        "concreteType": "TeamMemberConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          (v61/*: any*/),
                          {
                            "concreteType": "TeamMemberEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamMember",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v63/*: any*/),
                                  (v62/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "kudosEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "kudos",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  },
                  (v19/*: any*/),
                  (v27/*: any*/)
                ],
                "concreteType": "KudosConnection",
                "kind": "LinkedField",
                "name": "kudosTql",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "KudosEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Kudos",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v41/*: any*/),
                          (v43/*: any*/),
                          (v40/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "useCloudId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "department",
                "args": [
                  (v21/*: any*/),
                  (v26/*: any*/),
                  (v66/*: any*/)
                ],
                "concreteType": "PeopleFieldAggregateResponse",
                "kind": "LinkedField",
                "name": "peopleFieldAggregates",
                "plural": false,
                "selections": (v68/*: any*/)
              },
              {
                "alias": "location",
                "args": [
                  (v21/*: any*/),
                  (v26/*: any*/),
                  (v69/*: any*/)
                ],
                "concreteType": "PeopleFieldAggregateResponse",
                "kind": "LinkedField",
                "name": "peopleFieldAggregates",
                "plural": false,
                "selections": (v68/*: any*/)
              },
              {
                "alias": "jobTitle",
                "args": [
                  (v21/*: any*/),
                  (v26/*: any*/),
                  (v70/*: any*/)
                ],
                "concreteType": "PeopleFieldAggregateResponse",
                "kind": "LinkedField",
                "name": "peopleFieldAggregates",
                "plural": false,
                "selections": (v68/*: any*/)
              }
            ]
          },
          {
            "condition": "useCloudId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "departmentOld",
                "args": [
                  (v26/*: any*/),
                  (v66/*: any*/),
                  (v27/*: any*/)
                ],
                "concreteType": "PeopleFieldAggregateResponse",
                "kind": "LinkedField",
                "name": "peopleFieldAggregates",
                "plural": false,
                "selections": (v68/*: any*/)
              },
              {
                "alias": "locationOld",
                "args": [
                  (v26/*: any*/),
                  (v69/*: any*/),
                  (v27/*: any*/)
                ],
                "concreteType": "PeopleFieldAggregateResponse",
                "kind": "LinkedField",
                "name": "peopleFieldAggregates",
                "plural": false,
                "selections": (v68/*: any*/)
              },
              {
                "alias": "jobTitleOld",
                "args": [
                  (v26/*: any*/),
                  (v70/*: any*/),
                  (v27/*: any*/)
                ],
                "concreteType": "PeopleFieldAggregateResponse",
                "kind": "LinkedField",
                "name": "peopleFieldAggregates",
                "plural": false,
                "selections": (v68/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "isBrowsePeopleScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v21/*: any*/),
              (v28/*: any*/),
              {
                "kind": "Variable",
                "name": "searchString",
                "variableName": "userQuery"
              }
            ],
            "concreteType": "PeopleFieldAggregateResponse",
            "kind": "LinkedField",
            "name": "peopleFieldAggregates",
            "plural": false,
            "selections": [
              (v67/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "69e0f5c38ecb536d6d1541cd1794a30f",
    "id": null,
    "metadata": {},
    "name": "StaffDirectoryViewQuery",
    "operationKind": "query",
    "text": "query StaffDirectoryViewQuery(\n  $teamQuery: String!\n  $userQuery: String!\n  $kudosQuery: String!\n  $first: Int\n  $organisationId: String!\n  $workspaceId: ID!\n  $cloudId: String!\n  $peopleFieldType: PeopleFieldType!\n  $isSearchAllScreen: Boolean!\n  $isSearchPeopleScreen: Boolean!\n  $isSearchTeamsScreen: Boolean!\n  $isBrowseAllScreen: Boolean!\n  $isBrowsePeopleScreen: Boolean!\n  $isSearchKudosScreen: Boolean!\n  $kudosEnabled: Boolean!\n  $useCloudId: Boolean!\n) {\n  explainUserTql: explainTql(q: $userQuery, entity: PERSON) @skip(if: $isSearchKudosScreen) {\n    explanation\n  }\n  explainKudosTql: explainTql(q: $kudosQuery, entity: KUDOS) @include(if: $isSearchKudosScreen) {\n    explanation\n  }\n  ...SearchAllScreen_data_JbUE\n  ...SearchPeopleScreen_data_3UNIJZ\n  ...SearchTeamsScreen_data_3q3FiE\n  ...BrowseAllScreenQuery_4e9tE2 @include(if: $isBrowseAllScreen)\n  ...BrowsePeopleFieldsScreenQuery_2yJikX @include(if: $isBrowsePeopleScreen)\n  ...SearchKudosScreen_data_4d2Pna\n}\n\nfragment BrowseAllScreenQuery_4e9tE2 on Query {\n  ...BrowseTeamSection_Q9pCr\n  ...BrowseKudosSection_POC2h @include(if: $kudosEnabled)\n  ...BrowseDepartmentSection_2XiM35\n  ...BrowseLocationSection_2XiM35\n  ...BrowseJobTitleSection_2XiM35\n}\n\nfragment BrowseDepartmentSection_2XiM35 on Query {\n  department: peopleFieldAggregates(cloudId: $cloudId, peopleFieldType: DEPARTMENT, first: 4) @include(if: $useCloudId) {\n    ...BrowsePeopleFieldSection\n  }\n  departmentOld: peopleFieldAggregates(workspaceId: $workspaceId, peopleFieldType: DEPARTMENT, first: 4) @skip(if: $useCloudId) {\n    ...BrowsePeopleFieldSection\n  }\n}\n\nfragment BrowseJobTitleSection_2XiM35 on Query {\n  jobTitle: peopleFieldAggregates(cloudId: $cloudId, peopleFieldType: JOB_TITLE, first: 4) @include(if: $useCloudId) {\n    ...BrowsePeopleFieldSection\n  }\n  jobTitleOld: peopleFieldAggregates(workspaceId: $workspaceId, peopleFieldType: JOB_TITLE, first: 4) @skip(if: $useCloudId) {\n    ...BrowsePeopleFieldSection\n  }\n}\n\nfragment BrowseKudosSection_POC2h on Query {\n  kudos: kudosTql(workspaceId: $workspaceId, q: $kudosQuery, first: 5) {\n    edges {\n      node {\n        ...KudosContent\n        id\n      }\n    }\n  }\n}\n\nfragment BrowseLocationSection_2XiM35 on Query {\n  location: peopleFieldAggregates(cloudId: $cloudId, peopleFieldType: LOCATION, first: 4) @include(if: $useCloudId) {\n    ...BrowsePeopleFieldSection\n  }\n  locationOld: peopleFieldAggregates(workspaceId: $workspaceId, peopleFieldType: LOCATION, first: 4) @skip(if: $useCloudId) {\n    ...BrowsePeopleFieldSection\n  }\n}\n\nfragment BrowsePeopleFieldSection on PeopleFieldAggregateResponse {\n  results {\n    ...LocationCard\n    ...IllustrationCard\n  }\n  errors {\n    message\n  }\n}\n\nfragment BrowsePeopleFieldsScreenQuery_2yJikX on Query {\n  peopleFieldAggregates(searchString: $userQuery, cloudId: $cloudId, peopleFieldType: $peopleFieldType) {\n    results {\n      ...LocationCard\n      ...IllustrationCard\n    }\n  }\n}\n\nfragment BrowseTeamSection_Q9pCr on Query {\n  browseTeams: teamsTql(q: $teamQuery, first: 4, sort: [NAME_ASC], organisationId: $organisationId, cloudId: $cloudId) {\n    edges {\n      node {\n        ...TeamCard\n      }\n    }\n  }\n}\n\nfragment CardTeamsSection on CpusSearchUser {\n  teams {\n    edges {\n      node {\n        name\n        teamId\n        id\n      }\n    }\n  }\n}\n\nfragment IllustrationCard on PeopleFieldAggregate {\n  name\n  imageDirectoryUrl\n}\n\nfragment KudosContent on Kudos {\n  uuid\n  ari\n  description\n  imageUrl\n  stillImageUrl\n  type\n  bgTheme\n  giver {\n    pii {\n      name\n      picture\n      accountId\n    }\n    id\n  }\n  recipients(first: 1) {\n    edges {\n      node {\n        recipient {\n          pii {\n            accountId\n            name\n            picture\n          }\n          id\n        }\n        team {\n          name\n          teamId\n          avatarUrl\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment LocationCard on PeopleFieldAggregate {\n  name\n  imageDirectoryUrl\n}\n\nfragment PersonSearchResultCard on CpusSearchUser {\n  account_id\n  name\n  highResolutionProfilePicture(size: MEDIUM) {\n    url\n  }\n  job_title\n  reportCounts {\n    directReports\n  }\n  location\n  zoneinfo\n  ...CardTeamsSection\n}\n\nfragment SearchAllScreen_data_JbUE on Query {\n  peopleTql(q: $userQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchAllScreen) {\n    edges {\n      node {\n        account_id\n        ...PersonSearchResultCard\n      }\n    }\n  }\n  searchTeams: teamsTql(q: $teamQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchAllScreen) {\n    edges {\n      node {\n        id\n        ...TeamSearchResultCard\n      }\n    }\n  }\n}\n\nfragment SearchKudosScreen_data_4d2Pna on Query {\n  kudosTql(q: $kudosQuery, workspaceId: $workspaceId, first: 12) @include(if: $isSearchKudosScreen) {\n    edges {\n      node {\n        ...KudosContent\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SearchPeopleScreen_data_3UNIJZ on Query {\n  peopleTql(q: $userQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchPeopleScreen) {\n    edges {\n      node {\n        account_id\n        ...PersonSearchResultCard\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment SearchTeamsScreen_data_3q3FiE on Query {\n  searchTeams: teamsTql(q: $teamQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchTeamsScreen) {\n    edges {\n      node {\n        id\n        ...TeamSearchResultCard\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamCard on TeamSearchResponse {\n  id\n  displayName\n  description\n  isVerified\n  smallAvatarImageUrl\n  members {\n    count\n    edges {\n      node {\n        aaid\n        pii {\n          name\n          picture\n        }\n      }\n    }\n  }\n}\n\nfragment TeamSearchAvatar on TeamSearchResponse {\n  id\n  displayName\n  isVerified\n  largeAvatarImageUrl\n}\n\nfragment TeamSearchResultCard on TeamSearchResponse {\n  id\n  description\n  displayName\n  isVerified\n  smallAvatarImageUrl\n  ...TeamSearchAvatar\n  members {\n    count\n    edges {\n      node {\n        pii {\n          name\n          picture\n        }\n        aaid\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f2af49192e710fe5af58d589973a302";

export default node;
